import {
  Card,
  CardActionArea,
  CardContent,
  CardHeader,
  CardMedia,
  Grid,
  Typography,
} from "@mui/material"
import { LoadingIcon } from "components/Common/LoadingIcon"
import { useAppDispatch, useAppSelector } from "hooks"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import trainingModuleService from "services/trainingModuleService"
import { setCurrentTrainingModule, setTrainingModules } from "slices/trainingModuleSlice"
import type { ISimulatorApplication } from "types/simulatorApplicationTypes"
import type { ITrainingModule } from "types/trainingModuleTypes"
import { TrainingModuleCardMenu } from "./TrainingModuleCardMenu"

type Props = {
  app: ISimulatorApplication
}

export function TrainingModuleList({ app }: Props) {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const trainingModules = useAppSelector((state) => state.trainingmodule.trainingModules)

  useEffect(() => {
    if (trainingModules.length === 0) {
      setIsLoading(true)
    }

    trainingModuleService
      .getSimulatorApplicationsTrainingModules(app.id)
      .then((modules) => {
        dispatch(setTrainingModules(modules))
        setIsLoading(false)
      })
      .catch((err) => {
        console.log(err)
      })
  }, [app.id, dispatch, trainingModules.length])

  const handleClickTrianingModule = (module: ITrainingModule) => {
    dispatch(setCurrentTrainingModule(module))
    navigate(`/trainingmodule/${module.id}`)
  }

  return (
    <>
      {isLoading ? (
        <LoadingIcon />
      ) : (
        <Grid container spacing={2}>
          {trainingModules.map((module) => (
            <Grid key={module.id} item lg={4} md={6} xs={12}>
              <Card>
                <CardHeader
                  action={<TrainingModuleCardMenu trainingModule={module} />}
                  title={module.id}
                  titleTypographyProps={{ variant: "body2" }}
                ></CardHeader>
                <CardActionArea onClick={() => handleClickTrianingModule(module)}>
                  <CardMedia
                    component="img"
                    height="200"
                    image={module.imageUrl}
                    alt="Paella dish"
                  />
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                      {module.name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {module.description}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
    </>
  )
}
